import styled from 'styled-components';
import { h4Styles } from '@luigiclaudio/ga-baseline-ui/typography';

const ConversionResultsValue = styled.span.attrs(() => ({
    colorValue: 'muted',
}))`
    ${h4Styles}
`;

export default ConversionResultsValue;
